export const buttonSizes = {
  xs: {
    height: '22px',
    fontSize: '14px',
    letterSpacing: '0.15px',
  },
  sm: {
    height: '24px',
    fontSize: '14px',
    letterSpacing: '0.15px',
  },
  def: {
    height: '32px',
    fontSize: '14px',
  },
  md: {
    height: '32px',
    fontSize: '14px',
    lineHeight: '22px',
    letterSpacing: '0.15px',
    padding: '5px 15px',
  },
  lg: {
    height: '40px',
    fontSize: '16px',
  },
  xl: {
    height: '40px',
    fontSize: '16px',
    minWidth: '160px',
  },
};
